import { Typography } from "@mui/material";
import { OrderPaymentOptions } from "../../common/OrderPaymentOptions";
import { useTranslation } from "react-i18next";

const CheckoutStep6 = ({ step, paymentProviderId, onChangePaymentOption }) => {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h5" component="h2" sx={{ padding: "15px" }}>
        {step}. {t("Velg betalingsmåte")}
      </Typography>
      <OrderPaymentOptions
        onClick={(id) =>
          paymentProviderId > 0
            ? onChangePaymentOption(0)
            : onChangePaymentOption(id)
        }
        paymentProviderId={paymentProviderId}
      />
    </>
  );
};

export default CheckoutStep6;
